import { Component, OnInit } from '@angular/core';
import { USER_DATA } from 'src/assets/json/user-info';
import Typewriter from 't-writer.js';
import { SharedService } from '../../../services/shared.service'


@Component({
  selector: 'app-about-me',
  templateUrl: './about-me.component.html',
  styleUrls: ['./about-me.component.css', '../user-info/user-info.component.css']
})
export class AboutMeComponent implements OnInit {
  aboutUser: any;

  ngOnInit(): void {
    const target = document.getElementById('typeText');
    const writer = new Typewriter(target, {
      loop: true,
      typeSpeed: 80,
      deleteSpeed: 80,
      typeColor: '#022c67'
    })

    writer
      .type('Graduate Student')
      .rest(500)
      .remove(16)
      .type('Full Stack Developer')
      .rest(500)
      .changeOps({ deleteSpeed: 80 })
      .remove(20)
      .type('UI/UX Designer')
      .rest(500)
      .remove(14)
      .type('D365 Customizer')
      .rest(500)
      .clear()
      .start()
  }

  constructor(private _sharedService: SharedService) {
    this.aboutUser = USER_DATA.About;
  }

  scrollToContact(): void {
    document.getElementById('contact').scrollIntoView();
  }

  downloadResume(): void {
    this._sharedService.downloadResume();
  }

}
